import React from "react";
import "./FullscreenLoader.css";

const FullscreenLoader = ({ 
  text = "Loading...", 
  backgroundColor,
  spinnerColor,
  textColor
}) => {
  const customStyles = {};
  
  if (backgroundColor) {
    customStyles['--custom-background-color'] = backgroundColor;
  }
  if (spinnerColor) {
    customStyles['--custom-spinner-color'] = spinnerColor;
  }
  if (textColor) {
    customStyles['--custom-text-color'] = textColor;
  }

  return (
    <div className="fullscreen-loader" style={customStyles}>
      <div className="spinner"></div>
      <span className="loader-text">{text}</span>
    </div>
  );
};

export default FullscreenLoader; 